import { _get } from "./Axios";

export default class SatuanTargetApi {
  static get() {
    return _get("masterdata/satuan");
  }
}
